// Swipeable marketing tiles using slick slider
export default function marketingTiles(){
    $('.mt-swipeable').each(function(index){
        let el = $(this)
        $(this).slick({
            dots: true,
            arrows: false,
            appendDots: `.mt-dots-container--${index + 1}`,
            dotsClass: 'mt-dots',
            speed: 400,
            slidesToShow: 1,
            infinite: true
        })
        $(this).find('.slick-slide')
        .each(function(){
            const index = this.getAttribute('data-slick-index')
            const list = $(this).find('.mt-dots')
            list.find('li').each(function(itemIndex){
                if(itemIndex == index){
                    this.classList.add('dot-active')
                }
            })        
        })
        $(this).find('.mt-next-button').on('click', function(){
            el.slick('slickNext')
        })
        // $(this).find('.mt-arrow-button-prev').on('click', function(){
        //     el.slick('slickPrev')
        // })
    })
}   
